import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <section className="py-16 md:py-24 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20digital%20wave%20background%20with%20warm%20coral%20and%20golden%20gradient%2C%20soft%20smooth%20curves%2C%20modern%20minimalist%20tech%20aesthetic%2C%20gentle%20flowing%20shapes&width=1920&height=600&seq=cta-bg-mogu&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          随时随地，开启你的<span className="text-primary-600">精彩直播</span>之旅
        </h2>
        <p className="mt-4 text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
          下载蘑菇tv App，海量高清直播与短视频内容一手掌握。新用户注册即享7天会员体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <a
            href="#"
            className="px-8 py-3.5 rounded-xl bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-apple-line text-lg"></i> App Store
          </a>
          <a
            href="#"
            className="px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-android-line text-lg"></i> Google Play
          </a>
        </div>

        <div className="mt-10">
          <p className="text-xs text-foreground-500 mb-3">订阅蘑菇tv资讯，获取最新动态</p>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto">
            <div className="flex-1 w-full relative">
              <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                className="w-full pl-11 pr-4 py-3 rounded-xl bg-background-100 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              订阅
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}